export function requestFullscreen() {
  const el = document.documentElement as HTMLElement & { webkitRequestFullscreen?: () => void; msRequestFullscreen?: () => void };
  if (el.requestFullscreen) el.requestFullscreen();
  else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
  else if ((el as HTMLElement & { msRequestFullscreen?: () => void }).msRequestFullscreen) (el as HTMLElement & { msRequestFullscreen?: () => void }).msRequestFullscreen();
}

export function exitFullscreen() {
  const doc = document as Document & { webkitExitFullscreen?: () => void; msExitFullscreen?: () => void; webkitFullscreenElement?: Element };
  const inFullscreen = !!(
    doc.fullscreenElement ??
    (doc as Document & { webkitFullscreenElement?: Element }).webkitFullscreenElement
  );
  if (!inFullscreen) return;
  try {
    if (doc.exitFullscreen) doc.exitFullscreen();
    else if (doc.webkitExitFullscreen) doc.webkitExitFullscreen();
    else if (doc.msExitFullscreen) doc.msExitFullscreen();
  } catch {
    // Ignore if document is no longer active or fullscreen already exited
  }
}
